<script lang="ts">
  import { onMount } from "svelte"
  import { wait } from "$app/utils"
  import { appStore } from "$app/store.svelte"

  export let id = ""
  export let message = ""
  export let data: any = {}

  let elId = id === "goal" ? `goal-${data?.id}` : `task-${data?.id}`

  async function markId(): Promise<void> {
    const node = document.getElementById(elId)
    if (node) {
      node.style.borderColor = "blue"

      await wait(20)
      if (!node.classList.contains("duration-400"))
        node.classList.add("duration-400")

      node.classList.add("border-4")
      await wait(400)

      await wait(4000)
      node.classList.remove("border-4")
      node.style.borderColor = ""
    }
  }

  function getNode(q: string) {
    try {
      return document.querySelector(q)
    } catch {
      return null
    }
  }

  async function openNode(path: string): Promise<void> {
    const node = getNode(path) as HTMLElement

    if (node?.dataset?.expanded === "false") {
      node.dispatchEvent(new Event("click"))
      await wait(200)
    }
  }

  async function openGoal(): Promise<void> {
    await openNode("[data-name=departments-expander]")
    await openNode(`[data-name=department-${data.assignee_id}-expander]`)
  }

  async function openTask(): Promise<void> {
    const goal = appStore.goals.find((g) => g.id === data.goal_id)
    data.assignee_id = goal.assignee_id
    await openGoal()
    await wait(50)
    await openNode(`[data-name=goal-${goal.id}-expander]`)
  }

  async function scrolltoId(): Promise<void> {
    if (id.match(/task/)) await openTask()
    if (id.match(/goal/)) await openGoal()

    markId()
    let access = document.getElementById(elId)
    if (access) {
      access.scrollIntoView({ behavior: "smooth" })
    }
  }

  onMount(() => {
    try {
      markId()
    } catch (e) {}
  })
</script>

<div class="text-slate-800">
  <span class="text-green-600">{message}</span>
  {#if data?.id}
    <button on:click={scrolltoId} class="font-semibold underline text-blue-600">
      Click to view it
    </button>
  {/if}
</div>
